// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__i+iAL","cardWrapper":"Main_cardWrapper__jhdH0","functionWrapper":"Main_functionWrapper__ocsqm","row":"Main_row__H9zwS","card":"Main_card__MsUiy"};